/*
 *
 *  Notifications sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_INAPP_NOTIFICATION,
  CREATE_INAPP_NOTIFICATION,
  UPDATE_INAPP_NOTIFICATION,
  DELETE_INAPP_NOTIFICATION,

  LOAD_PUSH_NOTIFICATION,
  CREATE_PUSH_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION,
  DELETE_PUSH_NOTIFICATION,
  LOAD_NOTIFY_RECORDS_META_DATA,
} from "./constants";

import {
  // In-App
  loadInAppNotification,
  loadInAppNotificationSuccess,
  loadInAppNotificationError,

  createInAppNotificationSuccess,
  createInAppNotificationError,

  updateInAppNotificationSuccess,
  updateInAppNotificationError,

  deleteInAppNotificationSuccess,
  deleteInAppNotificationError,

  // Push
  loadPushNotification,
  loadPushNotificationSuccess,
  loadPushNotificationError,

  createPushNotificationSuccess,
  createPushNotificationError,

  updatePushNotificationSuccess,
  updatePushNotificationError,

  deletePushNotificationSuccess,
  deletePushNotificationError,

  loadNotifyRecordsMetaDataSuccess,
  loadNotifyRecordsMetaDataError,
} from "./actions";

import {
  // In-App
  loadInAppNotificationDetails,
  createInAppNotificationDetails,
  updateInAppNotificationDetails,
  deleteInAppNotificationDetails,

  // Push
  loadPushNotificationDetails,
  createPushNotificationDetails,
  updatePushNotificationDetails,
  deletePushNotificationDetails,
  loadNotifyRecordsMetaData
} from "./remotes";

/* ---------------- In-App Notification Sagas ---------------- */
//dopdown

function* loadNotifyRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_NOTIFY_RECORDS_META_DATA),
    });

    try {
      const user = yield call(loadNotifyRecordsMetaData, "getallsuperadminuser", "post", "user");
      const role = yield call(loadNotifyRecordsMetaData, "getrole", "post");

      let recordsMetaData = {

        roleOptions:
          (role &&
            role &&
            role.length > 0 &&
            role.map((c) =>
              Object.assign(
                {},
                {
                  label: c.roleName,
                  value: c._id,


                }
              )
            )) ||
          [],
        userOptions: (user.data &&
          user.data &&
          user.data.length > 0 &&
          user.data.map((c) =>
            Object.assign(
              {},
              {
                label: c.userName ? c.userName : c.mobileNo,
                value: c._id,
                roleName: c?.rolePrivileges?.[0]?.roleName
              }
            )
          )) ||
          [],
      };

      yield put(loadNotifyRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      console.log(error, "errorList")
      yield put(
        loadNotifyRecordsMetaDataError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}
// Load
function* loadInAppNotificationSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_INAPP_NOTIFICATION),
    });

    const { explicitLoad } = load;
    const { notificationsList } = explicitLoad || {};
    yield put(loadInAppNotification(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadInAppNotificationDetails, notificationsList);
        if (result) {
          yield put(loadInAppNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadInAppNotificationError(
            (error?.response?.message) || "Fetch Notifications Failed"
          )
        );
      }
    }
  }
}

// Create
function* createInAppNotificationSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_INAPP_NOTIFICATION),
    });

    const { notificationData } = create || {};

    if (create) {
      try {
        const result = yield call(createInAppNotificationDetails, notificationData);
        if (result) {
          yield put(createInAppNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          createInAppNotificationError(
            (error?.response?.message) || "Create Notification Failed"
          )
        );
      }
    }
  }
}

// Update
function* updateInAppNotificationSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_INAPP_NOTIFICATION),
    });

    const { notificationData } = update || {};

    if (update) {
      try {
        const result = yield call(updateInAppNotificationDetails, notificationData);
        if (result) {
          yield put(updateInAppNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          updateInAppNotificationError(
            (error?.response?.message) || "Update Notification Failed"
          )
        );
      }
    }
  }
}

// Delete
function* deleteInAppNotificationSaga() {
  while (true) {
    const { del } = yield race({
      del: take(DELETE_INAPP_NOTIFICATION),
    });

    const { notificationData } = del || {};

    if (del) {
      try {
        const result = yield call(deleteInAppNotificationDetails, notificationData);
        if (result) {
          yield put(deleteInAppNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          deleteInAppNotificationError(
            (error?.response?.message) || "Delete Notification Failed"
          )
        );
      }
    }
  }
}

/* ---------------- Push Notification Sagas ---------------- */

// Load
function* loadPushNotificationSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PUSH_NOTIFICATION),
    });

    const { explicitLoad } = load;
    const { notificationsList } = explicitLoad || {};
    yield put(loadPushNotification(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadPushNotificationDetails, notificationsList);
        if (result) {
          yield put(loadPushNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadPushNotificationError(
            (error?.response?.message) || "Fetch Push Notifications Failed"
          )
        );
      }
    }
  }
}

// Create
function* createPushNotificationSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PUSH_NOTIFICATION),
    });

    const { notificationData } = create || {};

    if (create) {
      try {
        const result = yield call(createPushNotificationDetails, notificationData);
        if (result) {
          yield put(createPushNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          createPushNotificationError(
            (error?.response?.message) || "Create Push Notification Failed"
          )
        );
      }
    }
  }
}

// Update
function* updatePushNotificationSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PUSH_NOTIFICATION),
    });

    const { notificationData } = update || {};

    if (update) {
      try {
        const result = yield call(updatePushNotificationDetails, notificationData);
        if (result) {
          yield put(updatePushNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          updatePushNotificationError(
            (error?.response?.message) || "Update Push Notification Failed"
          )
        );
      }
    }
  }
}

// Delete
function* deletePushNotificationSaga() {
  while (true) {
    const { del } = yield race({
      del: take(DELETE_PUSH_NOTIFICATION),
    });

    const { notificationData } = del || {};

    if (del) {
      try {
        const result = yield call(deletePushNotificationDetails, notificationData);
        if (result) {
          yield put(deletePushNotificationSuccess(result.data));
        }
      } catch (error) {
        yield put(
          deletePushNotificationError(
            (error?.response?.message) || "Delete Push Notification Failed"
          )
        );
      }
    }
  }
}

/* ---------------- Combine all ---------------- */
export default function* notificationsSaga() {
  yield all([
    // In-App
    loadInAppNotificationSaga(),
    createInAppNotificationSaga(),
    updateInAppNotificationSaga(),
    deleteInAppNotificationSaga(),

    // Push
    loadPushNotificationSaga(),
    createPushNotificationSaga(),
    updatePushNotificationSaga(),
    deletePushNotificationSaga(),
    loadNotifyRecordsMetaDataSaga()
  ]);
}
